import robleambiente from "../assets/ambientes/quattro-roble-ambiente.webp";
import roblepieza from "../assets/piezas/quattro-roble.webp";
import nogalambiente from "../assets/ambientes/quattro-nogal-ambiente.jpeg";
import nogalpieza from "../assets/piezas/quattro-nogal.webp";

import cherryambiente from "../assets/ambientes/quattro-cherry-ambiente.webp";
import cherrypieza from "../assets/piezas/quattro-cherry.webp";

import walnutambiente from "../assets/ambientes/quattro-walnut-ambiente.webp";
import walnutpieza from "../assets/piezas/quattro-walnut.webp"; 

import cinnamonambiente from "../assets/ambientes/quattro-cinnamon-ambiente.jpeg";
import cinnamonpieza from "../assets/piezas/quattro-cinnamon.webp"; 

import tekaambiente from "../assets/ambientes/quattro-teka-ambiente.webp";
import tekapieza from "../assets/piezas/quattro-teka.webp"; 

import mielambiente from "../assets/ambientes/quattro-miel-ambiente.webp";
import mielpieza from "../assets/piezas/quattro-miel.jpeg"; 

import arenapieza from "../assets/piezas/quattro-arena.webp"; 

import migdiapieza from "../assets/piezas/quattro-migdia.webp"; 

import starapieza from "../assets/piezas/quattro-star.webp"; 

import pianiambiente from "../assets/ambientes/quattro-pianni-ambiente.webp";
import pianipieza from "../assets/piezas/quattro-pianni.webp"; 

import neropieza from "../assets/piezas/quattrocolorespuros-nero.webp"; 

import oxfordpieza from "../assets/piezas/quattrocolorespuros-oxford.webp"; 

import settewalnutamb from "../assets/ambientes/sette-walnut-ambiente.jpeg";
import settewalnutpieza from "../assets/piezas/sette-walnut.webp"; 


import trepiannicinnamonpieza from "../assets/piezas/trepianni-cinnamon.jpeg"; 
import trepianninogalpieza from "../assets/piezas/trepianni-nogal.jpeg"; 

import scalacinnamonpieza from "../assets/piezas/scala-cinnamon.jpg"; 

import scalatravertineamb from "../assets/ambientes/scala-travertine-amb.jpeg"; 
import scalatravertinepieza from "../assets/piezas/scala-travertine.jpg"; 

import contouramb from "../assets/ambientes/panelcontour-travertine.jpeg"; 
import contourpieza from "../assets/piezas/panelcontour-travertine.jpeg"; 


import panelliso_cinnamon_pieza from "../assets/piezas/panel-liso-cinnamon.jpeg"; 

import panelliso_nogal_pieza from "../assets/piezas/panel-liso-nogal.png"; 

import panelliso_teka_pieza from "../assets/piezas/panel-liso-teka.png"; 

import panelliso_cherry_pieza from "../assets/piezas/panel-liso-cherry.png"; 

import panelbiselado_arena from "../assets/piezas/panelbiselado-arena.jpeg"; 

import panelbiselado_miel from "../assets/piezas/panelbiselado-miel.webp"; 

import panelbiselado_migia from "../assets/ambientes/panel-biselado-migdia.webp"; 
import panelbiselado_migdia_pieza from "../assets/piezas/panelbiselado-migdia.jpg"; 

import panelbiselado_star_pieza from "../assets/piezas/panelbiselado-star.jpg"; 

import panelbiselado_walnut_pieza from "../assets/piezas/panelbiselado-walnut.jpeg"; 

import viga10_cinnamon from "../assets/piezas/viga10-cinnamon.webp"; 

import viga10_nogal from "../assets/piezas/viga10-nogal.webp"; 

import viga15_cinnamon from "../assets/piezas/viga15-cinnamon.webp"; 

import viga15_nogal from "../assets/piezas/viga15-nogal.webp"; 

import esquinero_cherry from "../assets/piezas/esquinero-cherry.webp"; 

import iluminacion_ambiente from "../assets/ambientes/iluminacion-ambiente.webp"; 

import transformador from "../assets/piezas/transformador.webp"; 

import clipscolocacion from "../assets/piezas/clips.webp"; 

import soportefijo from "../assets/piezas/anclaje-viga.webp"; 

import soportegiratorio from "../assets/piezas/soporte-giratorio.jpeg"; 

import panel_stbarts_pieza from "../assets/piezas/stbarts-pieza.jpeg"; 

import panel_domek_ambiente from "../assets/ambientes/domek-ambiente.webp"; 
import panel_domek_pieza from "../assets/piezas/domek_pieza.jpeg"; 

import salonblack_pieza from "../assets/piezas/salonblack-pieza.jpeg"; 

import panel_parbat_ambiente from "../assets/ambientes/parbat-ambiente.webp"; 
import panel_parbat_pieza from "../assets/piezas/parbat-pieza.jpeg"; 

import panel_muzio_pieza from "../assets/piezas/panel-muzio.jpeg"; 

import panel_jaya_pieza from "../assets/piezas/panel-jaya.jpeg"; 

import panel_robson_pieza from "../assets/piezas/paneles-robson.jpeg"; 

import panel_singla_pieza from "../assets/piezas/panel_singla.jpeg"; 

import panel_titanium_pieza from "../assets/piezas/panel_titanium.jpeg"; 

import panel_bronze_pieza from "../assets/piezas/panel-bronze.jpeg"; 

import panel_electrogrey_pieza from "../assets/piezas/panel-electrogrey.jpeg"; 

import panel_gloomcopper_pieza from "../assets/piezas/gloom-copper-pieza.jpeg"; 

import panel_gloomgold_pieza from "../assets/piezas/gloom-gold.jpeg"; 

import panel_acoustic_pieza from "../assets/piezas/acustic.webp"; 

import panel_raindrop_pieza from "../assets/piezas/raindrop.webp"; 

import panel_dinamic_ambiente from "../assets/ambientes/dinamic-ambiente.jpeg"; 
import panel_dinamic_pieza from "../assets/piezas/electro-dinamicblack.jpeg"; 

import panel_espejo_pieza from "../assets/piezas/panel-espejo.jpg"; 

import panel_foresthaya_pieza from "../assets/piezas/forest-haya.jpg"; 
import panel_forestnogal_pieza from "../assets/piezas/forest-nogal.jpg"; 
import panel_forestgray_pieza from "../assets/piezas/forest-gray.jpg"; 

import panel_concrete_pieza from "../assets/piezas/concrete-oxford.webp"; 

import lvt_ozz from "../assets/piezas/ozz-black.webp"; 

import tenonak_ambiente from "../assets/ambientes/tenon-oak-ambiente.jpeg"; 
import tenon1 from "../assets/piezas/tenon1.jpg"; 
import tenon2 from "../assets/piezas/tenon2.jpg"; 
import tenon3 from "../assets/piezas/tenon3.jpg"; 


import douglas_brown_ambiente from "../assets/ambientes/douglas-brown-ambiente.jpeg"; 
import douglas_brown_pieza from "../assets/piezas/douglas-brown.jpeg"; 

import douglas_grey_pieza from "../assets/piezas/douglas-grey.jpeg"; 

import lawson_natural_ambiente from "../assets/ambientes/lawson-natural-ambiente.webp"; 
import lawson_natural_pieza from "../assets/piezas/lawson-natural.jpeg"; 

import lawson_silver_pieza from "../assets/piezas/lawson-silver.webp"; 

import palm_natural_ambiente from "../assets/ambientes/palm-natural-ambiente.webp"; 

import palm_natural_pieza from "../assets/piezas/palmnatural-pieza.jpeg"; 

import zoclo_lawson_pieza from "../assets/piezas/zoclo-lawson-natural.webp"; 

import zoclo_silver_pieza from "../assets/piezas/zoclo-lawsonsilver.webp"; 

import zoclo_douglasgrey_pieza from "../assets/piezas/zoclo-douglasgrey.webp"; 

import zoclo_douglasbrown_pieza from "../assets/piezas/zoclo-douglasbrown.webp"; 

import zoclo_palmnatural_pieza from "../assets/piezas/zoclo-palmnatural.webp"; 

import spc_colocacion1 from "../assets/piezas/clipcolocacion1.webp"; 
import spc_colocacion2 from "../assets/piezas/clipcolocacion2.webp"; 
import spc_colocacion3 from "../assets/piezas/clipcolocacion3.webp"; 

import spc_colocacion from "../assets/piezas/colocacion.webp"; 

import panelliso_exterior_mocha from "../assets/piezas/panelliso-mocha.jpeg"; 

import panelliso_exterior_almond from "../assets/piezas/panelliso-almond.jpeg"; 

import panelliso_exterior_chocolate from "../assets/piezas/panelliso-chocolate.webp"; 

import panelliso_exterior_caramel from "../assets/piezas/panelliso-caramel.webp"; 

import quattro_exterior_ambiente from "../assets/ambientes/quattroexterior-chocolate-ambiente.webp"; 
import quattro_exterior_pieza from "../assets/piezas/quattroexterior-chocolate-pieza.webp"; 

import quattroexterior_caramel_pieza from "../assets/piezas/quattroexterior-caramel-pieza.webp"; 

import quattroexterior_brunnete_pieza from "../assets/piezas/quattroexterior-brunette-pieza.webp"; 

import fiveexterior_almond_ambiente from "../assets/ambientes/five-exterior-almond.jpeg"; 

import fiveexterior_almond from "../assets/piezas/five-almond.jpeg"; 

import fiveexterior_mocha from "../assets/piezas/five-mocha.jpeg"; 

import vigaexterior_chocolate from "../assets/piezas/vigaexterior-chocolate.webp"; 
import vigaexterior_caramel from "../assets/piezas/vigaexterior-caramel.webp";
import vigaexterior_brunette from "../assets/piezas/vigaexterior-brunette.jpeg";  

import quattroesqexterior_chocolate from "../assets/piezas/quattroesqexterior-chocolate.webp";  
import quattroesqexterior_caramel from "../assets/piezas/quattroesqexterior-caramel.webp";  
import quattroesqexterior_brunette from "../assets/piezas/quattroesqexterior_brunette.png";  

import cubiertaviga from "../assets/piezas/cubierta-viga.webp";  
import clipexteriorpanel from "../assets/piezas/clipexterior-panel.webp";  
import clipquattro from "../assets/piezas/clipquattro.webp";  


import deckbicolor_chocolate from "../assets/piezas/deck-chocolate.webp";  
import deckbicolor_caramel from "../assets/piezas/deck-caramel.webp";  

import deckbicolor_mocha from "../assets/piezas/deck-mocha.jpeg";  
import deckbicolor_almond from "../assets/piezas/deck-almond.jpeg"; 

import moldurawpc_chocolate from "../assets/piezas/moldurawpcchocolate.webp"; 
import moldurawpc_caramel from "../assets/piezas/moldurawpccaramel.webp"; 

import clipdeck_exterior from "../assets/piezas/clipdeck-exterior.webp"; 




export default {
    "categories": [
        {
            id: 1,
            name: "Wood-Plastic Composite",
            category: "wpc"
        },
        {
            id: 2,
            name: "Paneles Decorativos",
            category: "paneles-decorativos"
        },
        {
            id: 3,
            name: "Pisos Vinílicos de Alta Calidad",
            category: "lvt"
        },
        {
            id: 4,
            name: "Pisos Vinílicos Multicapa",
            category: "spc"
        },
        {
            id: 5,
            name: "Exteriores Deck",
            category: "deck"
        },
    ],
    "products": [
        {
            //COLECCION QUATTRO
            id: 3,
            name: "Roble",
            category: "wpc",
            subcategory: "quattro",
            size: ["290 x 16 x 2.4 cm"],
            color: ["Roble"],
            piece: "10",
            image: robleambiente,
            gallery:[roblepieza],
            description: "Lambrín decorativo WPC, Colección Quattro, cuatro líneas.",
            datasheet: "Wpc_quattro",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },
        {
            id: 4,
            name: "Nogal",
            category: "wpc",
            subcategory: "quattro",
            size: ["290 x 16 x 2.4 cm"],
            color: ["Nogal"],
            piece: "10",
            image: nogalambiente,
            gallery: [nogalpieza],
            description: "Lambrín decorativo WPC, Colección Quattro, cuatro líneas.",
            datasheet: "Wpc_quattro",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },
        {
            id: 1,
            name: "Cherry",
            category: "wpc",
            subcategory: "quattro",
            size: ["290 x 16 x 2.4 cm"],
            color: ["Cherry"],
            piece: "10",
            image: cherryambiente,
            gallery: [cherrypieza],
            description: "Lambrín decorativo WPC, Colección Quattro, cuatro líneas.",
            datasheet: "Wpc_quattro",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },
        {
            id: 5,
            name: "Walnut",
            category: "wpc",
            subcategory: "quattro",
            size: ["290 x 16 x 2.4 cm"],
            color: ["Walnut"],
            piece: "10",
            image: walnutambiente,
            gallery: [walnutpieza],
            description: "Lambrín decorativo WPC, Colección Quattro, cuatro líneas.",
            datasheet: "Wpc_quattro",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },
        //COLECCION QUATTRO HOJA 013
        {
            id: 6,
            name: "Cinnamon",
            category: "wpc",
            subcategory: "quattro",
            size: ["290 x 16 x 2.4 cm"],
            color: ["Cinnamon"],
            image: cinnamonambiente,
            gallery: [cinnamonpieza],
            piece: "10",
            description: "Lambrín decorativo WPC, Colección Quattro, cuatro líneas.",
            datasheet: "Wpc_quattro",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },
        {
            id: 8,
            name: "Teka",
            category: "wpc",
            subcategory: "quattro",
            size: ["290 x 16 x 2.4 cm"],
            color: ["Teka"],
            image: tekaambiente,
            gallery: [tekapieza],
            piece: "10",
            description: "Lambrín decorativo WPC, Colección Quattro, cuatro líneas.",
            datasheet: "Wpc_quattro",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },
        {
            id: 107,
            name: "Miel",
            category: "wpc",
            subcategory: "quattro",
            size: ["290 x 16 x 2.4 cm"],
            color: ["Miel"],
            image: mielambiente,
            gallery: [mielpieza],
            description: "Lambrín decorativo WPC, Colección Quattro, cuatro líneas.",
            datasheet: "Wpc_quattro",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },
        {
            id: 66,
            name: "Arena",
            category: "wpc",
            subcategory: "quattro",
            size: ["290 x 16 x 2.4 cm"],
            color: ["Arena"],
            image: arenapieza,
            description: "Lambrín decorativo WPC, Colección Quattro, cuatro líneas.",
            datasheet: "Wpc_quattro",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },
        //COLECCION QUATTRO HOJA 015

        {
            id: 64,
            name: "Migdia",
            category: "wpc",
            subcategory: "quattro",
            size: ["290 x 16 x 2.4 cm"],
            color: ["Migdia"],
            image: migdiapieza,
            description: "Lambrín decorativo WPC, Colección Quattro, cuatro líneas.",
            datasheet: "Wpc_quattro",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },
        {
            id: 65,
            name: "Star",
            category: "wpc",
            subcategory: "quattro",
            size: ["290 x 16 x 2.4 cm"],
            color: ["Star"],
            image: starapieza,
            description: "Lambrín decorativo WPC, Colección Quattro, cuatro líneas.",
            datasheet: "Wpc_quattro",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],

        },
        {
            id: 39,
            name: "Pianni Ébano Mix",
            category: "wpc",
            subcategory: "quattro",
            size: ["290 x 15.2 x 1.2 cm"],
            color: ["Ebano Mix"],
            piece: "10",
            image: pianiambiente,
            gallery: [pianipieza],
            description: "Lambrín decorativo WPC, Colección Quattro, cuatro líneas.",
            datasheet: "Wpc_quattropianni",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },
        //COLECCION QUATTRO COLORES PUROS
        {
            id: 2,
            name: "Nero",
            category: "wpc",
            subcategory: "Quattro Colores Puros",
            size: ["290 x 16 x 2.4 cm"],
            color: ["Nero"],
            piece: "10",
            image: neropieza,
            description: "Lambrín decorativo WPC, Colección Quattro Colores Puros, cuatro líneas.",
            datasheet: "Wpc_quattropianni",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },
        {
            id: 38,
            name: "Oxford",
            category: "wpc",
            subcategory: "Quattro Colores Puros",
            size: ["290 x 16 x 2.4 cm"],
            color: ["Oxford"],
            piece: "10",
            image: oxfordpieza,
            description: "Lambrín decorativo WPC, Colección Quattro Colores Puros, cuatro líneas.",
            uniqueimage: true,
            datasheet: "Wpc_colorespuros",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },
        // COLECCION SETTE
        {
            id: 12,
            name: "Walnut",
            category: "wpc",
            subcategory: "sette",
            size: ["290 x 15.8 x 1.5 cm"],
            color: ["Walnut"],
            image: settewalnutamb,
            gallery: [settewalnutpieza],
            piece: "10",
            description: "Lambrín decorativo WPC, Colección Sette, siete líneas.",
            datasheet: "Wpc_sette",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },
        // COLECCION TRE PIANNI
        {
            id: 401,
            name: "Nogal",
            category: "wpc",
            subcategory: "Tre Pianni",
            size: ["290 x 19.5 x 1.6 cm"],
            color: ["Nogal"],
            piece: "10",
            image: trepianninogalpieza,
            description: "Lambrín decorativo WPC, Colección Tre Pianni, tres líneas.",
            datasheet: "Wpc_trepiannix",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },

        {
            id: 43,
            name: "Cinnamon",
            category: "wpc",
            subcategory: "Tre Pianni",
            size: ["290 x 19.5 x 1.6 cm"],
            color: ["Cinnamon"],
            piece: "10",
            image: trepiannicinnamonpieza,
            description: "Lambrín decorativo WPC, Colección Tre Pianni, tres líneas.",
            datasheet: "Wpc_trepiannix",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },

        //COLECCION SCALA

        {
            id: 402,
            name: "Cinnamon",
            category: "wpc",
            subcategory: "Scala",
            size: ["290 x 18 x 2 cm"],
            color: ["Cinnamon"],
           
            image: scalacinnamonpieza,
            description: "Lambrín decorativo WPC, Colección Scala.",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },

        {
            id: 403,
            name: "Travertine",
            category: "wpc",
            subcategory: "Scala",
            size: ["290 x 18 x 2 cm"],
            color: ["Travertine"],
            image: scalatravertineamb,
            gallery: [scalatravertinepieza],
            description: "Lambrín decorativo WPC, Colección Scala.",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },

        //WPC PANELES VIGAS ESQUINEROS

        {
            id: 404,
            name: "Travertine",
            category: "wpc",
            subcategory: "panel contour",
            size: ["290 x 30 x 2.5 cm"],
            color: ["Travertine"],
            image: contouramb,
            gallery: [contourpieza],
            description: "Lambrín decorativo WPC, Colección Panel Contour.",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],
        },

        //COLECCION PANEL LISO

        {
            id: 45,
            name: "Cinnamon",
            category: "wpc",
            subcategory: "panel liso",
            size: ["290 x 60 x .8 cm"],
            color: ["Cinnamon"],
            image: panelliso_cinnamon_pieza,
            description: "Panel liso WPC.",
            datasheet: "Panel_sinbisel",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"],

        },
        {
            id: 46,
            name: "Nogal",
            category: "wpc",
            subcategory: "panel liso",
            size: ["290 x 60 x .8 cm"],
            color: ["Nogal"],
            image: panelliso_nogal_pieza,
            description: "Panel liso WPC.",
            datasheet: "Panel_sinbisel",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]

        },

        {
            id: 405,
            name: "Teka",
            category: "wpc",
            subcategory: "panel liso",
            size: ["290 x 60 x .8 cm"],
            color: ["Teka"],
            image: panelliso_teka_pieza ,
            description: "Panel liso WPC.",
            datasheet: "Panel_sinbisel",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]

        },

        {
            id: 406,
            name: "Cherry",
            category: "wpc",
            subcategory: "panel liso",
            size: ["290 x 60 x .8 cm"],
            color: ["Cherry"],
            image: panelliso_cherry_pieza,
            description: "Panel liso WPC.",
            datasheet: "Panel_sinbisel",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]

        },

        //COLECCION PANEL BISELADO

        {
            id: 70,
            name: "Arena",
            category: "wpc",
            subcategory: "panel biselado",
            size: ["290 x 60 x .8 cm"],
            color: ["Arena"],
            image: panelbiselado_arena,
            description: "Panel Biselado WPC.",
            piece: "1",
            uniqueimage: true,
            datasheet: "panel_biselado",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Biselado"]

        },
        {
            id: 67,
            name: "Miel",
            category: "wpc",
            subcategory: "panel biselado",
            size: ["290 x 60 x .8 cm"],
            color: ["Miel"],
            image: panelbiselado_miel,
            uniqueimage: true,
            description: "Panel Biselado WPC.",
            datasheet: "panel_biselado",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Biselado"]
        },
        {
            id: 68,
            name: "Migdia",
            category: "wpc",
            subcategory: "panel biselado",
            size: ["290 x 60 x .8 cm"],
            color: ["Migdia"],
            image: panelbiselado_migia,
            gallery: [panelbiselado_migdia_pieza],
            description: "Panel Biselado WPC.",
            datasheet: "panel_biselado",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Biselado"]
        },


        {
            id: 69,
            name: "Star",
            category: "wpc",
            subcategory: "panel biselado",
            size: ["290 x 60 x .8 cm"],
            color: ["Star"],
            image: panelbiselado_star_pieza,
            description: "Panel Biselado WPC.",
            uniqueimage: true,
            datasheet: "panel_biselado",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Biselado"]
        },

        {
            id: 407,
            name: "Walnut",
            category: "wpc",
            subcategory: "panel biselado",
            size: ["290 x 60 x .8 cm"],
            color: ["Walnut"],
            image: panelbiselado_walnut_pieza,
            description: "Panel Biselado WPC.",
            uniqueimage: true,
            datasheet: "panel_biselado",
            middlecategory: "interior",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Biselado"]
        },

        //VIGAS

        {
            id: 48,
            name: "Viga 10 Cinnamon",
            category: "wpc",
            subcategory: "vigas",
            size: ["290 x 10 x 5 cm"],
            color: ["Cinnamon"],
            image: viga10_cinnamon,
            description: "Viga 10 WPC",
            datasheet: "Vigas_interior",
            middlecategory: "interior",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },


        {
            id: 200,
            name: "Viga 10 Nogal",
            category: "wpc",
            subcategory: "vigas",
            size: ["290 x 10 x 5 cm"],
            color: ["Nogal"],
            image: viga10_nogal,
            description: "Viga 10 WPC",
            datasheet: "Vigas_interior",
            middlecategory: "interior",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]

        },

        {
            id: 202,
            name: "Viga 15 Cinnamon",
            category: "wpc",
            subcategory: "vigas",
            size: ["290 x 15 x 5 cm"],
            color: ["Cinnamon"],
            image: viga15_cinnamon,
            description: "Viga 10 WPC",
            datasheet: "Vigas_interior",
            middlecategory: "interior",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]

        },

        {
            id: 201,
            name: "Viga 15 Nogal",
            category: "wpc",
            subcategory: "vigas",
            size: ["290 x 15 x 5 cm"],
            color: ["Nogal"],
            image: viga15_nogal,
            description: "Viga WPC.",
            datasheet: "Vigas_interior",
            middlecategory: "interior",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]

        },

        //ESQUINEROS

        {
            id: 19,
            name: "Esquinero",
            category: "wpc",
            subcategory: "esquineros",
            size: ["290 x 3 x 3 cm"],
            other: "Disponible en todos los colores de la colección WPC",
            image: esquinero_cherry,
            description: "Esquinero decorativo. Disponible en varios colores.",
            color: ["Cherry", "Walnut", "Oxford", "Nero", "Cinnamon", "Pianni", "Nogal", "Arena", "Migdia", "Roble"
                , "Miel", "Star", "Teka"
            ],
            uniqueimage: true,
            datasheet: "Esquineros",
            middlecategory: "interior",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },
        //FALTANTE COLORES

        //ILUMINCACIÓN Y COLOCACIÓN

        {
            id: 22,
            name: "Kit de Iluminación Led Serie Quattro",
            category: "wpc",
            size: ["60 cm", "100 cm", "150 cm"],
            subcategory: "Iluminación y Colocación",
            piece: "1",
            other: "100 cm controlador",
            image: iluminacion_ambiente,
            description: "Luz Led Quattro & Sette",
            datasheet: "luz_led",
            middlecategory: "interior"
        },
        {

            //checar medidas
            id: 20,
            name: "Transformador 150W",
            category: "wpc",
            subcategory: "Iluminación y Colocación",
            piece: "1",
            other: "150w | Entrada 110v | Salida 24v",
            image: transformador,
            description: "Refacción de transformador.",
            uniqueimage: true,
            middlecategory: "interior"
        },

        {
            id: 55,
            name: "Clips de Colocación",
            category: "wpc",
            subcategory: "Iluminación y Colocación",
            image: clipscolocacion,
            description: "Clips de colocación",
            uniqueimage: true,
            middlecategory: "interior"
        },
        {
            id: 76,
            name: "Soporte Fijo para Viga 10",
            category: "wpc",
            subcategory: "Iluminación y Colocación",
            image: soportefijo,
            description: "Anclaje para Viga",
            uniqueimage: true,
            middlecategory: "exterior"
        },
        {
            id: 76,
            name: "Soporte giratorio para Viga 10 y 15",
            category: "wpc",
            subcategory: "Iluminación y Colocación",
            image: soportegiratorio,
            description: "Anclaje para Viga",
            uniqueimage: true,
            middlecategory: "exterior"
        },

        {
            id: 80,
            name: "St Barts",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["280 x 122 x .3 cm"],
            image: panel_stbarts_pieza,
            description: "Paneles Decorativos",
            uniqueimage: true,
            datasheet: "Paneles_UVMarble",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Brillo",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },
        {
            id: 81,
            name: "Domek",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["280 x 122 x .3 cm"],
            image: panel_domek_ambiente,
            gallery: [panel_domek_pieza],
            description: "Paneles Decorativos",
            datasheet: "Paneles_UVMarble",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Brillo",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },
        {
            id: 82,
            name: "Salon Black",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["280 x 122 x .3 cm"],
            image: salonblack_pieza,
            description: "Paneles Decorativos",
            uniqueimage: true,
            datasheet: "Paneles_UVMarble",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Brillo",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },

        {
            id: 83,
            name: "Parbat",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["244 x 122 x .3 cm"],
            image: panel_parbat_ambiente,
            gallery: [panel_parbat_pieza],
            description: "Paneles Decorativos",
            datasheet: "Paneles_UVMarble",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Brillo",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },
        {
            id: 84,
            name: "Muzio",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["244 x 122 x .3 cm"],
            image: panel_muzio_pieza,
            description: "Paneles Decorativos",
            uniqueimage: true,
            datasheet: "Paneles_UVMarble",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Brillo",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },
        {
            id: 85,
            name: "Jaya",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["244 x 122 x .3 cm"],
            image: panel_jaya_pieza,
            description: "Paneles Decorativos",
            uniqueimage: true,
            datasheet: "Paneles_UVMarble",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Brillo",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },
        {
            id: 86,
            name: "Robson",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["244 x 122 x .3 cm"],
            image: panel_robson_pieza,
            description: "Paneles Decorativos",
            uniqueimage: true,
            datasheet: "Paneles_UVMarble",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Brillo",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },

        {
            id: 408,
            name: "Singla",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["244 x 122 x .3 cm"],
            image: panel_singla_pieza,
            description: "Paneles Decorativos",
            uniqueimage: true,
            datasheet: "Paneles_UVMarble",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Brillo",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },

        {
            id: 87,
            name: "Titanium",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["280 x 122 x .5 cm"],
            image: panel_titanium_pieza,
            description: "Paneles Decorativos",
            uniqueimage: true,
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Metalizado",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },

        {
            id: 410,
            name: "Bronze",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["280 x 122 x .5 cm"],
            image: panel_bronze_pieza,
            description: "Paneles Decorativos",
            uniqueimage: true,
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Metalizado",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },

        {
            id: 62,
            name: "Electro Grey",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["280 x 122 x .5 cm"],
            image: "electro",
            description: "Paneles Decorativos",
            color: ["Grey"],
            image: panel_electrogrey_pieza,
            datasheet: "Paneles_Electro",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Metalizado",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },
        {
            id: 89,
            name: "Gloom Copper",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["244 x 122 x .5 cm"],
            image: panel_gloomcopper_pieza,
            description: "Paneles Decorativos",
            uniqueimage: true,
            datasheet: "Paneles_Electro",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Metalizado",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },
        {
            id: 90,
            name: "Gloom Gold",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["244 x 122 x .5 cm"],
            image: panel_gloomgold_pieza,
            description: "Paneles Decorativos",
            uniqueimage: true,
            datasheet: "Paneles_Electro",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Metalizado",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },
        {
            id: 94,
            name: "Acoustic",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["280 x 122 x .5 cm"],
            image: panel_acoustic_pieza,
            description: "Paneles Decorativos",
            uniqueimage: true,
            datasheet: "Paneles_Electro",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },

        {
            id: 93,
            name: "Rain Drop",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["280 x 122 x .5 cm"],
            image: panel_raindrop_pieza ,
            description: "Paneles Decorativos",
            uniqueimage: true,
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },
        {
            id: 92,
            name: "Dinamic",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["280 x 122 x .5 cm"],
            image: panel_dinamic_ambiente,
            gallery: [panel_dinamic_pieza],
            description: "Paneles Decorativos",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },
        {
            id: 95,
            name: "Panel Espejo",
            category: "Paneles Decorativos",
            subcategory: "Interior",
            size: ["244 x 122 x .5 cm"],
            image: panel_espejo_pieza,
            description: "Paneles Decorativos",
            datasheet: "Paneles_Electro",
            uso: "Muro",
            lugardeuso: "Residencial Comercial",
            acabado: "Brillo",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza"]
        },
        //LVT INTERIORES
        {
            id: 28,
            name: "Haya",
            category: "lvt",
            size: ["17.78 x 121.92 x 3.5 cm"],
            subcategory: "forest",
            color: ["Haya"],
            image: panel_foresthaya_pieza,
            description: "Piso Vinílico de Alta Calidad.",
            datasheet: "LVT_Forest",
            uso: "Piso",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Antiderrape", "Antisonido"]
        },

        {
            id: 411,
            name: "Nogal",
            category: "lvt",
            size: ["17.78 x 121.92 x 3.5 cm"],
            subcategory: "forest",
            color: ["Haya"],
            image: panel_forestnogal_pieza,
            description: "Piso Vinílico de Alta Calidad.",
            datasheet: "LVT_Forest",
            uso: "Piso",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Antiderrape", "Antisonido"]
        },

        {
            id: 30,
            name: "Grey",
            category: "lvt",
            size: ["17.78 x 121.92 x 3.5 cm"],
            subcategory: "forest",
            color: ["Grey"],
            image: panel_forestgray_pieza,
            description: "Piso Vinílico de Alta Calidad.",
            datasheet: "LVT_Forest",
            uso: "Piso",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Antiderrape", "Antisonido"]
        },
        
        //COLECCION CONCRETE

        {
            id: 34,
            name: "Oxford",
            category: "lvt",
            size: ["91.44 x 45 x 3.3 cm"],
            subcategory: "Concrete",
            color: ["Oxford"],
            image: panel_concrete_pieza,
            description: "Piso Vinílico de Alta Calidad.",
            datasheet: "LVT_Concrete",
            uso: "Piso",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Antiderrape", "Antisonido"]
        },

        //COLECCION OZZ

        {
            id: 35,
            name: "Black",
            category: "lvt",
            size: ["45.72 x 91.44 x 3.3 cm"],
            subcategory: "Ozz",
            color: ["Black"],
            image: lvt_ozz,
            description: "Piso Vinílico de Alta Calidad.",
            datasheet: "LVT_Ozz",
            uso: "Piso",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Antiderrape"]
        },

    
        //SPC INTERIOR
        //COLECCION TENON
        {
            id: 23,
            name: "Oak",
            category: "spc",
            size: ["12.7 x 63.5 cm"],
            subcategory: "Tenon",
            color: ["Oak"],
            image: tenonak_ambiente,
            gallery: [tenon1, tenon2, tenon3],
            description: "Piso Vinílico Multicapa.",
            datasheet: "SPC_Douglas",
            uso: "Piso",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Antiderrape", "Antisonido"]
        },

        //COLECCION DOUGLAS

        {
            id: 23,
            name: "Brown",
            category: "spc",
            size: ["18.2 x 122 x .5 cm"],
            subcategory: "Douglas",
            color: ["Brown"],
            image: douglas_brown_ambiente,
            gallery: [douglas_brown_pieza],
            description: "Piso Vinílico Multicapa.",
            datasheet: "SPC_Douglas",
            uso: "Piso",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Antiderrape", "Antisonido"]
        },
        {
            id: 52,
            name: "Grey",
            category: "spc",
            size: ["18.2 x 122 x .5 cm"],
            subcategory: "Douglas",
            color: ["Grey"],
            image: douglas_grey_pieza,
            description: "Piso Vinílico Multicapa.",
            uniqueimage: true,
            datasheet: "SPC_Douglas",
            uso: "Piso",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Antiderrape", "Antisonido"]
        },

        //COLECCION LAWSON

        {
            id: 24,
            name: "Natural",
            category: "spc",
            size: ["18.2 x 122 x .5 cm"],
            subcategory: "Lawson",
            color: ["Natural"],
            image: lawson_natural_ambiente,
            gallery: [lawson_natural_pieza ],
            description: "Piso Vinílico Multicapa.",
            datasheet: "SPC_Lawson",
            uso: "Piso",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Antiderrape", "Antisonido"]
        },

        {
            id: 53,
            name: "Silver",
            category: "spc",
            size: ["18.2 x 122 x .5 cm"],
            subcategory: "Lawson",
            color: ["Silver"],
            image: lawson_silver_pieza,
            description: "Piso Vinílico Multicapa.",
            datasheet: "SPC_Lawson",
            uso: "Piso",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Antiderrape", "Antisonido"]
        },

        //COLECCION LAWSON

        {
            id: 27,
            name: "Natural",
            category: "spc",
            size: ["18.2 x 122 x .6 cm"],
            subcategory: "Palm",
            color: ["Natural"],
            image: palm_natural_ambiente,
            gallery: [palm_natural_pieza],
            description: "Piso Vinílico Multicapa.",
            datasheet: "SPC_Palm",
            uso: "Piso",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interior",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Antiderrape", "Antisonido"]

        },
        //ZOCLO SPC
        {
            id: 49,
            name: "Lawson Natural",
            category: "spc",
            subcategory: "Zoclo SPC",
            size: ["5 x 220 cm"],
            color: ["Natural"],
            image: zoclo_lawson_pieza,
            description: "Zoclo SPC.",
            uniqueimage: true,
        },

        {
            id: 300,
            name: "Lawson Silver",
            category: "spc",
            subcategory: "Zoclo SPC",
            size: ["5 x 220 cm"],
            color: ["Silver"],
            image: zoclo_silver_pieza,
            description: "Zoclo SPC.",
            uniqueimage: true,
        },
        {
            id: 50,
            name: "Douglas Grey",
            category: "spc",
            subcategory: "Zoclo SPC",
            size: ["5 x 220 cm"],
            color: ["Grey"],
            image: zoclo_douglasgrey_pieza,
            description: "Zoclo SPC.",
            uniqueimage: true,
        },
        {
            id: 3001,
            name: "Douglas Brown",
            subcategory: "Zoclo SPC",
            category: "spc",
            subcategory: "Zoclo SPC",
            size: ["5 x 220 cm"],
            color: ["Brown"],
            image: zoclo_douglasbrown_pieza,
            description: "Zoclo SPC.",
            uniqueimage: true,
        },
        {
            id: 51,
            name: "Palm Natural",
            category: "spc",
            subcategory: "Zoclo SPC",
            size: ["5 x 220 cm"],
            color: ["Natural"],
            image: zoclo_palmnatural_pieza,
            description: "Zoclo SPC.",
            uniqueimage: true,
        },

        //COLOCACION SPC

        {
            id: 106,
            name: "Clips de Colocación",
            category: "spc",
            subcategory: "Colocación SPC",
            image: spc_colocacion1,
            gallery: [spc_colocacion2, spc_colocacion3],
            description: "Clip SPC",
        },
        {
            id: 97,
            name: "Colocación",
            category: "spc",
            subcategory: "Colocación SPC",
            image: spc_colocacion,
            description: "Colocación",
            uniqueimage: true,
        },

        //WPC EXTERIORES

        //FALTANTE MOCHA
        //FALTANTE ALMOND

        {
            id: 420,
            name: "Mocha",
            category: "wpc",
            size: ["290 x 17.4 x 2.1 cm"],
            subcategory: "Panel Liso Exterior",
            image:panelliso_exterior_mocha,
            description: "Exteriores WPC.",
            color: ["Mocha"],
            datasheet: "Panel_lisoexterior",
            middlecategory: "exterior",
            uso: "Muro y Techo",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Exterior",
            caracteristicas: ["Fácil Instalación", "Resistente al Agua"]
        },


        {
            id: 420,
            name: "Almond",
            category: "wpc",
            size: ["290 x 17.4 x 2.1 cm"],
            subcategory: "Panel Liso Exterior",
            image: panelliso_exterior_almond ,
            description: "Exteriores WPC.",
            color: ["Almon"],
            datasheet: "Panel_lisoexterior",
            middlecategory: "exterior",
            uso: "Muro y Techo",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Exterior",
            caracteristicas: ["Fácil Instalación", "Resistente al Agua"]
        },

        {
            id: 71,
            name: "Chocolate",
            category: "wpc",
            size: ["290 x 17.4 x 2.1 cm"],
            subcategory: "Panel Liso Exterior",
            description: "Exteriores WPC.",
            color: ["Chocolate"],
            image: panelliso_exterior_chocolate,
            datasheet: "Panel_lisoexterior",
            middlecategory: "exterior",
            uso: "Muro y Techo",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Exterior",
            caracteristicas: ["Fácil Instalación", "Resistente al Agua"]


        },
        {
            id: 72,
            name: "Caramel",
            category: "wpc",
            size: ["290 x 17.4 x 2.1 cm"],
            subcategory: "Panel Liso Exterior",
            image: panelliso_exterior_caramel,
            description: "Exteriores WPC.",
            color: ["Caramel"],
            uniqueimage: true,
            datasheet: "Panel_lisoexterior",
            middlecategory: "exterior",
            uso: "Muro y Techo",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Exterior",
            caracteristicas: ["Fácil Instalación", "Resistente al Agua"]
        },

        //Quattro Exterior

        {
            id: 91,
            name: "Chocolate",
            category: "wpc",
            size: ["290 x 21.9 x 2.6 cm"],
            subcategory: "Quattro Exterior",
            image: quattro_exterior_ambiente,
            gallery: [quattro_exterior_pieza],
            description: "Exteriores WPC.",
            color: ["Chocolate"],
            datasheet: "Wpc_quattroexterior",
            middlecategory: "exterior",
            uso: "Muro y Techo",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Exterior",
            caracteristicas: ["Fácil Instalación", "Resistente al Agua"]
        },
        {
            id: 73,
            name: "Caramel",
            category: "wpc",
            size: ["290 x 21.9 x 2.6 cm"],
            subcategory: "Quattro Exterior",
            image: quattroexterior_caramel_pieza,
            description: "Exteriores WPC.",
            color: ["Caramel"],
            uniqueimage: true,
            datasheet: "Wpc_quattroexterior",
            middlecategory: "exterior",
            uso: "Muro y Techo",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Exterior",
            caracteristicas: ["Fácil Instalación", "Resistente al Agua"]
        },
        {
            id: 104,
            name: "Brunette",
            category: "wpc",
            size: ["290 x 21.9 x 2.6 cm"],
            subcategory: "Quattro Exterior",
            image: quattroexterior_brunnete_pieza,
            description: "Exteriores WPC.",
            color: ["Brunette"],
            uso: "Muro y Techo",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Exterior",
            caracteristicas: ["Fácil Instalación", "Resistente al Agua"]
        },
        //FIVE EXTERIOR

        {
            id: 430,
            name: "Almond",
            category: "wpc",
            size: ["290 x 21.9 x 2.6 cm"],
            subcategory: "Five Exterior",
            image: fiveexterior_almond_ambiente,
            gallery: [fiveexterior_almond],
            description: "Exteriores WPC.",
            color: ["Almond"],
            middlecategory: "exterior",
            uso: "Muro y Techo",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Exterior",
            caracteristicas: ["Fácil Instalación", "Resistente al Agua"]
        },
        {
            id: 431,
            name: "Mocha",
            category: "wpc",
            size: ["290 x 21.9 x 2.6 cm"],
            subcategory: "Five Exterior",
            image: fiveexterior_mocha,
            description: "Exteriores WPC.",
            color: ["Mocha"],
            middlecategory: "exterior",
            uso: "Muro y Techo",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Exterior",
            caracteristicas: ["Fácil Instalación", "Resistente al Agua"]
        },


        //VIGAS EXTERIOR WPC

        {
            id: 58,
            name: "Viga Chocolate",
            category: "wpc",
            subcategory: "Vigas Exterior",
            size: ["290 x 10 x 5 cm"],
            image: vigaexterior_chocolate,
            description: "Exteriores WPC",
            color: ["Chocolate"],
            datasheet: "Vigas_exterior",
            uniqueimage: true,
            uso: "Muro y Techo",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Exterior",
            caracteristicas: ["Fácil Instalación", "Resistente al Agua"]
        },
        {
            id: 304,
            name: "Viga Caramel",
            category: "wpc",
            subcategory: "Vigas Exterior",
            size: ["290 x 10 x 5 cm"],
            image: vigaexterior_caramel ,
            description: "Exteriores WPC",
            color: ["Caramel"],
            datasheet: "Vigas_exterior",
            uniqueimage: true,
            uso: "Muro y Techo",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Exterior",
            caracteristicas: ["Fácil Instalación", "Resistente al Agua"]
        },
        {
            id: 305,
            name: "Viga Brunette",
            category: "wpc",
            subcategory: "Vigas Exterior",
            size: ["290 x 10 x 5 cm"],
            image: vigaexterior_brunette,
            description: "Exteriores WPC",
            color: ["Brunette"],
            datasheet: "Vigas_exterior",
            uniqueimage: true,
            uso: "Muro y Techo",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Exterior",
            caracteristicas: ["Fácil Instalación", "Resistente al Agua"]
        },

        //Colocacion Exteriores

        {
            id: 75,
            name: "Esquinero Quattro Chocolate",
            category: "wpc",
            subcategory: "Colocación Exteriores",
            image: quattroesqexterior_chocolate,
            description: "Exteriores WPC Esquinero.",
            color: ["Chocolate"],
            uniqueimage: true,
            middlecategory: "exterior"
        },
        {
            id: 74,
            name: "Esquinero Quattro Caramel",
            category: "wpc",
            subcategory: "Colocación Exteriores",
            image: quattroesqexterior_caramel,
            description: "Exteriores WPC Esquinero.",
            color: ["Caramel"],
            uniqueimage: true,
            middlecategory: "exterior"
        },

        {
            id: 432,
            name: "Esquinero Quattro Brunette",
            category: "wpc",
            subcategory: "Colocación Exteriores",
            image: quattroesqexterior_brunette,
            description: "Exteriores WPC Esquinero.",
            color: ["Brunette"],
            uniqueimage: true,
            middlecategory: "exterior"
        },


        //¿Repetido?

        {
            id: 77,
            name: "Cubierta para Viga",
            category: "wpc",
            subcategory: "Colocación Exteriores",
            image: cubiertaviga,
            description: "Cubierta para viga",
            uniqueimage: true,
            middlecategory: "exterior"
        },

        {
            id: 78,
            name: "Clip Exterior para Panel",
            category: "wpc",
            subcategory: "Colocación Exteriores",
            image: clipexteriorpanel ,
            description: "Clip Panel Exterior.",
            uniqueimage: true,
            middlecategory: "exterior"
        },
        {
            id: 79,
            name: "Clip para Quattro",
            category: "wpc",
            subcategory: "Colocación Exteriores",
            image: clipquattro,
            description: "Clip WPC Exterior.",
            uniqueimage: true,
            middlecategory: "exterior"
        },
        //Deck Exteriores
        {
            id: 98,
            name: "Deck Bicolor Chocolate Caramel",
            category: "Deck",
            size: ["290 x 13.8 x 2.3 cm"],
            subcategory: "Deck Bicolor",
            image: deckbicolor_chocolate,
            gallery: [deckbicolor_caramel],
            description: "Deck Exterior WPC, Bicolor Chocolate/Caramel.",
            color: ["Chocolate/Caramel"],
            datasheet: "Deck_exterior",
            uso: "Piso",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Exterior",
            caracteristicas: ["Fácil Instalación", "Resistente al Agua", "Resistente al Fuego"]
        },

        {
            id: 433,
            name: "Deck Bicolor Mocha Almond",
            category: "Deck",
            size: ["290 x 13.8 x 2.3 cm"],
            subcategory: "Deck Bicolor",
            image: deckbicolor_mocha,
            gallery: [deckbicolor_almond],
            description: "Deck Exterior WPC, Bicolor Chocolate/Caramel.",
            color: ["Mocha/Almond"],
            datasheet: "Deck_exterior",
            uso: "Piso",
            lugardeuso: "Residencial Comercial",
            acabado: "Texturizado",
            ambiente: "Exterior",
            caracteristicas: ["Fácil Instalación", "Resistente al Agua", "Resistente al Fuego"]
        },

        //Accesorios
        {
            id: 100,
            name: "Moldura WPC Chocolate",
            category: "Deck",
            size: ["290 x 5.5 x 5 cm"],
            subcategory: "Accesorios",
            image: moldurawpc_chocolate,
            description: "Moldura Deck WPC Chocolate.",
            color: ["Chocolate"],
            uniqueimage: true,
            uso: "Piso",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interiores",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Antiderrape", "Antisonido"]
        },
        {
            id: 101,
            name: "Moldura WPC Caramel",
            category: "Deck",
            size: ["290 x 5.5 x 5 cm"],
            subcategory: "Accesorios",
            image: moldurawpc_caramel,
            description: "Moldura Deck WPC Caramel.",
            color: ["Caramel"],
            uniqueimage: true,
            uso: "Piso",
            lugardeuso: "Residencial Comercial",
            acabado: "Mate",
            ambiente: "Interiores",
            caracteristicas: ["Fácil Instalación", "Fácil Limpieza", "Antiderrape", "Antisonido"]
        },

        {
            id: 102,
            name: "Clip Deck Exterior",
            category: "Deck",
            subcategory: "Accesorios",
            image: clipdeck_exterior,
            description: "Clip para Deck Exteriores",
            uniqueimage: true,
        },


        //ACABA
    ]
}